import WarehouseStepStatus from "../../entities/WarehouseStepStatus";

class WarehouseStepResponse {
    public id: string;
    public warehouseId: string;
    public warehouseName: string;
    public status: WarehouseStepStatus;
    public assignedAt: number;
    public dispatchedAt: number | null;
    public dispatchedBy: string | null;

    constructor(
        id: string,
        warehouseId: string,
        warehouseName: string,
        status: WarehouseStepStatus,
        assignedAt: number,
        dispatchedAt: number | null = null,
        dispatchedBy: string | null = null,
    ) {
        this.id = id;
        this.warehouseId = warehouseId;
        this.warehouseName = warehouseName;
        this.status = status;
        this.assignedAt = assignedAt;
        this.dispatchedAt = dispatchedAt;
        this.dispatchedBy = dispatchedBy;
    }
}

export default WarehouseStepResponse;
